import { Link, Typography as Text } from '@material-ui/core';

import { RiExternalLinkLine } from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isSafeUrl } from '@spotify/plugin-confidence-artifacts-react';

import styles from './ExternalUrlArtifactContent.module.css';

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  /** Optional UI URL. Omit it when the artifact has no navigable UI. */
  href?: string;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  href,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const label = artifact.displayName || fallbackTitle(artifact);
  const safeUrl = href && isSafeUrl(href) ? href : undefined;

  return (
    <div className={styles.info}>
      {safeUrl ? (
        <Link
          href={safeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          {label}
          <RiExternalLinkLine size={14} />
        </Link>
      ) : (
        <Text variant="body1">{label}</Text>
      )}
    </div>
  );
};
